// extracted by mini-css-extract-plugin
export default {"wrapper":"AddNotifsEmail_wrapper__EmZcO","title":"AddNotifsEmail_title__SCZ+d","content":"AddNotifsEmail_content__y8B+D"};